/**
 * Optional base URL for the public marketing / landing site (separate deploy).
 * Set VITE_LANDING_URL in the app env when the landing site is available.
 */
export function getLandingBaseUrl() {
  const raw = import.meta.env.VITE_LANDING_URL;
  if (!raw || typeof raw !== 'string') return '';
  return raw.replace(/\/$/, '');
}

/** @param {string} path e.g. "/contact" */
export function getLandingUrl(path) {
  const base = getLandingBaseUrl();
  if (!base) return '';
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${base}${p}`;
}
